<template>
  <div
    class="layout-container-horizontal"
    :style="{
      '--containerBgColor': variables[`${style}-container-background`],
    }"
  >
    <ht-nav-bar />

    <el-menu
      background-color="#316AFF"
      text-color="#ADD0FF"
      active-text-color="#FFFFFF"
      :style="{
        '--menuBgColor': variables[`${style}-menu-background`],
        left: '0px',
      }"
      :default-active="activeMenu"
      mode="horizontal"
      menu-trigger="hover"
    >
      <template v-for="route in currentShowMenu">
        <ht-side-bar-item
          v-if="!route.hidden"
          :key="route.id"
          :full-path="route.path"
          :item="route"
        />
      </template>
    </el-menu>

    <div class="app-main">
      <ht-app-main />
    </div>
  </div>
</template>

<script>
  import variables from '@/styles/variables.scss'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'HorizontalLayout',
    data() {
      return {
        variables,
      }
    },
    computed: {
      ...mapGetters({
        routes: 'routes/routes',
        style: 'settings/style',
      }),

      ...mapState('routes', ['menus']),

      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },

      currentShowMenu() {
        const menu = this.menus.find((_item, index) => index === 6)
        if (!menu) return this.routes
        const menuIndex = this.routes.findIndex((it) => it.path === menu.path)
        const currentMenuList = this.routes.filter(
          (_menu, index) => index <= menuIndex
        )
        const otherMenus = this.routes.filter(
          (_menu, index) => index > menuIndex
        )
        if (otherMenus && otherMenus.length > 0) {
          currentMenuList.push({
            alwaysShow: true,
            children: otherMenus,
            name: 'moreMenu',
            meta: { icon: 'icon-gengduo2' },
            path: '/more',
          })
        }

        return currentMenuList
      },
    },
  }
</script>

<style lang="scss" scoped>
  .layout-container-horizontal {
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .nav-bar-container,
    .el-menu {
      flex: none;
    }

    .app-main {
      display: flex;
      flex: 1;
      padding: 8px;
      overflow: hidden auto;

      ::v-deep {
        .nav-bar-container {
          .fold-unfold {
            display: none;
          }
        }

        .app-main-container {
          margin-top: 0;
          background: var(--containerBgColor);
        }
      }
    }
  }
</style>
